// removed by extract-text-webpack-plugin
module.exports = {"slidingHorizontal":"_12t5PAp9NSd_C_sdIo5VA0","slidein-left":"_2B8MvpWj6QW4JCT0VgJ9xx","subTabGame":"smXSadml7zJGQbYE8yXM2","subTabGameSelected":"_32XH6uJnSZC_PI5OANxgYR","matchdaySubtab":"_3TLa6Pw9jfmzBnAPbibS1Q","subTabContainer":"_1gSJXyqiBlL7d2_XpoVZ11","liveScore":"_2Tmbv-Oyz14GTv2XueU0Ha","teamName":"_2UTVJE5TX94AJqPiDHFfoN","teamNameGreek":"_1TZ7LWQU_MB8m8UG0lG09j","loading":"_3w_d-gHO5Zf-EmkLHEyenl","blink":"P3v8bDd5F1z_AZ22Q8-fA"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/gameSubTab.css
// module id = 292
// module chunks = 0